import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 500.000000 500.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)">

<path d="M2240 3199 c-211 -102 -404 -296 -484 -487 -59 -141 -71 -204 -70
-382 0 -151 3 -173 28 -255 107 -348 350 -588 695 -683 85 -23 115 -26 251
-26 130 0 169 3 240 23 315 84 567 314 676 615 11 31 11 37 1 33 -9 -3 -13 3
-13 17 1 21 -5 23 -37 10 -17 -6 -17 -2 -10 47 4 30 8 128 8 219 -1 141 -4
174 -21 225 -30 85 -67 169 -76 173 -4 2 -8 8 -8 13 0 19 -72 119 -127 175
-66 69 -166 145 -235 180 -181 92 -401 118 -612 73 -71 -16 -101 -18 -104 -10
-2 6 -9 11 -16 11 -19 0 -7 58 13 63 12 4 13 5 1 6 -8 0 -53 -18 -100 -40z
m605 -54 c101 -29 182 -64 241 -105 25 -17 50 -28 55 -24 5 3 8 2 7 -3 -2 -5
15 -25 37 -44 51 -44 125 -117 125 -123 0 -3 20 -33 44 -68 58 -83 71 -111
107 -221 49 -149 54 -348 14 -502 -76 -294 -352 -534 -675 -585 -260 -41 -538
47 -737 233 -264 247 -342 639 -194 970 74 165 194 297 366 404 154 96 414
125 610 68z"/>
<path d="M2281 3009 c-93 -46 -208 -164 -255 -259 -72 -149 -67 -321 12 -439
21 -30 45 -59 54 -65 26 -16 68 13 90 60 l18 42 -35 58 c-19 31 -37 66 -41 76
-7 25 -21 23 -27 -4 -13 -55 -40 -117 -48 -112 -23 14 -41 120 -37 211 5 88 7
95 48 159 24 36 54 73 67 81 13 9 33 32 43 52 22 44 103 123 148 145 17 9 32
19 32 21 0 8 -4 6 -69 -26z"/>
<path d="M2770 2917 c-17 -8 -42 -47 -82 -127 -69 -140 -238 -517 -238 -530 0
-6 30 -10 68 -10 l67 0 36 83 37 82 131 3 c72 1 131 4 131 6 0 2 -11 28 -25
58 l-24 53 -80 5 -80 5 56 123 c31 67 60 119 64 115 3 -5 44 -93 89 -198 45
-104 98 -223 116 -262 l34 -73 71 0 c55 0 70 3 66 13 -22 57 -266 580 -284
610 -34 55 -96 72 -153 44z"/>
<path d="M2300 2828 c-22 -24 -130 -235 -130 -255 0 -14 40 -103 46 -103 2 0
9 11 14 25 9 24 13 25 94 25 l85 0 -17 40 c-16 38 -19 40 -64 40 -27 0 -48 5
-48 10 0 6 11 32 25 58 14 26 25 52 25 58 0 6 6 16 13 22 9 8 24 -16 65 -103
28 -63 52 -123 52 -134 0 -11 -22 -49 -50 -85 -55 -74 -50 -85 13 -27 27 26
54 65 76 115 l33 75 -58 116 c-32 64 -67 123 -78 131 -30 21 -72 17 -96 -8z"/>
<path d="M2101 2153 c-5 -11 -16 -37 -24 -59 -8 -21 -18 -47 -22 -56 -5 -13
-3 -18 8 -18 8 0 17 7 21 15 3 9 18 15 36 15 20 0 30 -5 30 -15 0 -8 7 -15 15
-15 19 0 19 -2 -6 67 -28 75 -43 93 -58 66z m29 -64 c0 -12 -5 -19 -11 -17 -6
2 -10 7 -10 11 1 4 1 14 1 23 0 8 5 12 10 9 6 -3 10 -15 10 -26z"/>
<path d="M2200 2095 c0 -60 3 -75 15 -75 12 0 15 15 15 75 0 60 -3 75 -15 75
-12 0 -15 -15 -15 -75z"/>
<path d="M2257 2163 c-2 -5 -5 -38 -6 -75 -1 -55 1 -68 14 -68 12 0 15 14 15
75 0 65 -9 92 -23 68z"/>
<path d="M2980 2095 c0 -60 3 -75 15 -75 12 0 15 15 15 75 0 60 -3 75 -15 75
-12 0 -15 -15 -15 -75z"/>
<path d="M2360 2090 l0 -70 40 0 c49 0 80 27 80 70 0 43 -31 70 -80 70 l-40 0
0 -70z m71 40 c42 -23 16 -90 -35 -90 -12 0 -16 11 -16 43 0 58 11 68 51 47z"/>
<path d="M2850 2090 c0 -54 3 -70 14 -70 8 0 16 10 18 23 2 15 11 23 28 25 36
5 50 20 50 52 0 32 -15 40 -71 40 l-39 0 0 -70z m83 38 c7 -23 -4 -38 -29 -38
-19 0 -24 5 -24 25 0 20 5 25 24 25 13 0 26 -6 29 -12z"/>
<path d="M2610 2131 c-7 -13 -7 -22 0 -26 5 -3 10 -24 10 -46 0 -35 3 -39 25
-39 27 0 34 15 10 24 -20 7 -19 52 0 60 13 5 12 9 -5 26 -25 25 -27 25 -40 1z"/>
<path d="M2514 2115 c-18 -14 -17 -14 14 -15 17 0 32 -4 32 -10 0 -5 -11 -10
-24 -10 -29 0 -49 -22 -40 -44 4 -11 19 -16 50 -16 l44 0 0 39 c0 61 -35 87
-76 56z m46 -65 c0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10 0 6 9 10 20 10 11 0
20 -4 20 -10z"/>
<path d="M2708 2123 c-29 -7 -20 -23 12 -23 17 0 30 -4 30 -10 0 -5 -13 -10
-29 -10 -34 0 -45 -12 -36 -40 5 -16 15 -20 51 -20 l44 0 0 39 c0 57 -23 77
-72 64z m37 -74 c-8 -12 -35 -12 -35 0 0 11 22 20 33 14 4 -2 5 -9 2 -14z"/>
<path d="M3036 2123 c-8 -8 -8 -66 0 -87 4 -11 19 -16 50 -16 l44 0 0 50 c0
38 -4 50 -15 50 -11 0 -15 -11 -15 -40 0 -33 -3 -40 -20 -40 -17 0 -20 7 -20
39 0 38 -10 57 -24 44z"/>
<path d="M3170 2113 c-42 -29 -10 -107 36 -89 8 3 14 -1 14 -11 0 -12 -7 -14
-30 -9 -37 7 -40 -11 -3 -20 43 -11 58 6 61 73 l3 61 -31 4 c-17 3 -39 -2 -50
-9z m53 -27 c3 -8 -1 -22 -8 -33 -13 -17 -15 -17 -31 -1 -9 9 -14 24 -11 32 8
20 43 21 50 2z"/>
<path d="M2687 1908 c11 -13 24 -33 28 -46 9 -32 -18 -72 -50 -72 -14 0 -25
-4 -25 -10 0 -19 -29 -10 -50 17 -16 20 -23 24 -32 15 -16 -16 -29 -15 -25 1
1 9 -44 12 -198 13 -129 1 -186 -1 -160 -6 22 -5 75 -9 117 -9 42 -1 80 -5 83
-11 3 -5 41 -10 84 -10 70 0 80 -2 101 -25 25 -27 97 -52 110 -38 49 51 80 99
80 123 0 35 -35 80 -62 80 l-21 0 20 -22z"/>
<path d="M2594 1895 c-9 -14 -14 -28 -10 -32 3 -3 6 -1 6 6 0 7 5 9 13 5 6 -4
9 -3 4 1 -4 5 0 17 10 27 9 10 11 18 5 18 -6 0 -19 -11 -28 -25z"/>
<path d="M2632 1878 c-18 -18 -14 -46 7 -58 38 -20 71 13 51 51 -12 21 -40 25
-58 7z"/>
<path d="M2230 1870 c-36 -4 6 -7 123 -8 112 -1 177 2 177 8 0 11 -209 11
-300 0z"/>
<path d="M2795 1870 c4 -6 69 -9 168 -8 131 1 148 3 92 8 -111 12 -267 11
-260 0z"/>
<path d="M2790 1815 c0 -13 20 -15 153 -9 259 11 285 21 55 23 -180 1 -208 -1
-208 -14z"/>
<path d="M1331 1114 c-18 -52 -31 -98 -27 -101 3 -3 10 6 15 21 9 23 16 26 60
26 45 0 49 -2 56 -27 4 -16 10 -22 12 -16 7 18 -58 193 -71 193 -6 0 -26 -43
-45 -96z m58 54 c5 -13 12 -38 16 -55 6 -32 6 -33 -29 -33 -40 0 -41 2 -25 51
6 19 12 40 15 47 5 18 13 15 23 -10z"/>
<path d="M1668 1204 c-5 -4 -8 -49 -8 -101 l0 -93 61 0 c37 0 58 4 54 10 -3 6
-26 10 -50 10 l-44 0 -3 91 c-2 50 -6 87 -10 83z"/>
<path d="M1827 1203 c-4 -3 -7 -48 -7 -100 l0 -93 34 0 c43 0 85 16 102 38 16
20 18 96 4 122 -16 29 -113 54 -133 33z m99 -21 c19 -12 34 -49 34 -81 0 -44
-31 -71 -80 -71 l-40 0 0 80 0 80 38 0 c20 0 42 -4 48 -8z"/>
<path d="M2050 1114 c-18 -52 -30 -98 -27 -101 4 -3 9 6 12 20 6 21 13 26 52
29 52 4 58 1 68 -30 4 -13 9 -21 12 -18 9 9 -61 196 -73 196 -7 0 -27 -43 -44
-96z m76 -8 c6 -25 4 -26 -34 -26 l-41 0 15 43 c26 75 25 74 40 41 7 -17 16
-43 20 -58z"/>
<path d="M2200 1200 c0 -6 30 -10 70 -10 40 0 70 4 70 10 0 6 -30 10 -70 10
-40 0 -70 -4 -70 -10z"/>
<path d="M2427 1184 c-21 -42 -59 -165 -53 -172 3 -2 10 7 15 21 8 21 17 25
56 29 44 3 48 1 60 -27 23 -53 16 -6 -12 73 -34 100 -46 114 -66 76z m32 -16
c5 -13 12 -38 16 -55 6 -32 6 -33 -29 -33 -40 0 -41 2 -25 51 6 19 12 40 15
47 5 18 13 15 23 -10z"/>
<path d="M2578 1204 c-11 -18 -9 -184 1 -184 6 0 11 15 11 34 0 31 2 34 40 39
23 3 47 11 55 17 19 16 19 64 0 80 -18 15 -100 26 -107 14z m102 -34 c18 -34
-4 -60 -50 -60 -40 0 -40 0 -40 40 0 40 0 40 40 40 29 0 42 -5 50 -20z"/>
<path d="M3153 1190 c-83 -50 -29 -206 59 -170 20 8 19 9 -13 9 -46 1 -69 26
-69 77 0 57 22 84 69 84 20 0 42 -5 49 -12 8 -8 12 -8 12 -1 0 9 -50 33 -69
33 -3 0 -20 -9 -38 -20z"/>
<path d="M3445 1196 c-31 -13 -55 -51 -55 -87 0 -58 64 -109 113 -90 25 10 55
41 39 41 -5 0 -15 -7 -22 -15 -7 -8 -27 -15 -46 -15 -40 0 -64 29 -64 80 0 53
23 80 69 80 20 0 42 -5 49 -12 8 -8 12 -8 12 -1 0 8 -55 36 -64 33 -1 -1 -15
-7 -31 -14z"/>
<path d="M3654 1202 c-33 -5 -56 -36 -61 -85 -7 -59 27 -101 82 -101 55 0 89
42 82 101 -7 66 -42 94 -103 85z m64 -28 c28 -19 31 -97 5 -126 -20 -22 -70
-23 -95 -1 -24 21 -25 99 -1 125 20 22 61 23 91 2z"/>
<path d="M3822 1113 l2 -98 5 85 6 85 29 -75 c44 -115 49 -116 82 -21 16 44
32 81 36 81 4 0 9 -37 11 -82 3 -77 3 -76 3 15 -1 57 -5 98 -11 98 -5 1 -23
-35 -40 -80 -16 -44 -33 -81 -36 -81 -4 0 -19 37 -36 82 -41 115 -53 113 -51
-9z"/>
<path d="M1512 1108 l-2 -98 56 0 c34 0 53 4 49 10 -3 6 -26 10 -50 10 l-44 0
-4 88 -3 87 -2 -97z"/>
<path d="M2762 1108 l-2 -98 50 0 c28 0 50 5 50 10 0 6 -20 10 -45 10 l-44 0
-4 88 -3 87 -2 -97z"/>
<path d="M2910 1138 c0 -87 15 -112 67 -116 62 -5 73 13 71 106 l-1 77 -6 -75
c-3 -41 -10 -81 -14 -87 -10 -16 -69 -17 -85 -1 -7 7 -12 42 -12 85 0 42 -4
73 -10 73 -6 0 -10 -27 -10 -62z"/>
<path d="M2260 1094 c0 -54 4 -83 10 -79 6 3 10 42 10 86 0 46 -4 79 -10 79
-6 0 -10 -35 -10 -86z"/>
<path d="M3223 1103 c22 -4 27 -10 28 -34 2 -41 3 -46 12 -55 4 -4 7 16 7 44
l0 52 -37 -1 c-31 -2 -33 -3 -10 -6z"/>
<path d="M3325 1030 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
